module.exports = __webpack_public_path__ + "static/img/Consulting04.4373699b.png";